import { RecordBase } from '../../providers/request/record-base.model';
import { FileType } from '../form/file-type.enum';
import { ProjectFormExecuteType } from '../form/project-form-execute-type.enum';
import { ArchiveFileStatus } from './archive-file-status.enum';
export class BaseArchiveFile extends RecordBase {
  fileId?: string;
  fileChange?: boolean;
  fileName?: string;
  fileTitle?: string;
  fileType?: FileType;
  fileSize?: number;
  filePageCount?: number;
  fileSignType?: boolean;
  filePath?: string;
  fileMd5?: string;
  fileAuthor?: string;
  fileStatus?: ArchiveFileStatus;
  comment?: string;
}
